import React from 'react';
import { TeamRoleCard } from '../../cards';
import styles from './teamRolesDisplay.scss';

const TeamRoles = (props) => {
    const { clubDetails, isAdminOrOwner, typeOfTeamRolesName, clubType, auth, sendMessage } = props;
    const { teamRoles, clubOrganizers, clubMembers } = clubDetails;
    const { isCollege } = clubDetails?.tierType || {};
    const clubMemberIds = clubMembers.map(member => member.memberId);

    return (
        <div>
            <h6>{typeOfTeamRolesName}</h6>
            {teamRoles && teamRoles.length ? (
                <div className={`${styles.teamRoles}`}>
                    {teamRoles.map((teamRole, i) => {
                        let playerProfileId;
                        const showPaidHit = clubMemberIds.includes(teamRole.memberId);

                        if (showPaidHit) {
                            const player = clubMembers.find(member => member.memberId === teamRole.memberId);
                            playerProfileId = player.id;
                        }

                        return (
                            <TeamRoleCard
                                key={`teamRole-${i}`}
                                teamRole={teamRole}
                                showPaidHitButton={showPaidHit}
                                playerId={playerProfileId}
                                isCollege={isCollege}
                                user={auth.user}
                                clubOrganizers={clubOrganizers}
                                sendMessage={sendMessage}
                            />
                        );
                    })}
                </div>
            ) : (
                <div className={`${styles.teamRolesEmpty}`}>
                    <p>No {typeOfTeamRolesName} added</p>
                </div>
            )}
            {isAdminOrOwner && (
                <div className="mt8">
                    <a href={`/${clubType}/${clubDetails.id}/teams/roles/manage`} className={`${styles.manageTeamRoles} underline`}>Manage {typeOfTeamRolesName}</a>
                </div>
            )}
        </div>
    );
};

export default TeamRoles;
